import { makeStyles, Theme } from '@material-ui/core/styles'

const useMuseStyles = makeStyles((theme: Theme) => ({
    primaryColor: {
        color: '#F9CC04',
    },

    textWhiteColor: {
        color: '#f1f1f1',
    },

    textDarkColor: {
        color: '#ccc',
    },

    backgroundDarkColor: {
        color: '#202122',
    },

    textEllipsis: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },

    textBreakSpaces: {
        whiteSpace: 'break-spaces',
        overflow: 'hidden',
    },

    textBreakAll: {
        whiteSpace: 'break-spaces',
        overflow: 'hidden',
        wordBreak: 'break-all',
    },

    textSmaller: {
        fontSize: '90% !important',
    },

    textSmaller95: {
        fontSize: '95%',
    },

    textSmaller85: {
        fontSize: '85% !important',
    },

    textSmaller80: {
        fontSize: '80% !important',
    },

    textSmaller70: {
        fontSize: '70% !important',
    },

    textLarger: {
        fontSize: '110%',
        fontWeight: 'bold',
    },

    buttonSmall: {
        minWidth: '32px',
        '& .MuiButton-label': {
            fontSize: '90%',
        },
    },

    buttonColorWhite: {
        borderColor: '#f1f1f1 !important',
        '& .MuiButton-label': {
            color: '#f1f1f1',
        },
    },

    buttonColorDanger: {
        borderColor: '#ff4e4e !important',
        '& .MuiButton-label': {
            color: '#ff4e4e',
        },
    },

    buttonColorDangerFilled: {
        borderColor: '#ff4e4e !important',
        background: '#ff4e4e !important',
        '& .MuiButton-label': {
            color: '#202122',
        },
        '&:hover': {
            background: '#ff4e4e !important',
            border: '1px solid #ff4e4e !important',
        },
    },

    buttonColorSuccess: {
        borderColor: '#2faf2f !important',
        '& .MuiButton-label': {
            color: '#2faf2f',
        },
    },

    buttonColorPrimary: {
        borderColor: '#F9CC04 !important',
        '& .MuiButton-label': {
            color: '#F9CC04',
        },
    },

    buttonColorGreen: {
        borderColor: '#2faf2f !important',
        '& .MuiButton-label': {
            color: '#2faf2f',
        },
    },

    buttonColorGrayout: {
        opacity: '0.6',
    },

    popupButton: {
        border: '1px solid #F9CC04 !important',
        padding: '0px 20px',
        borderRadius: '16px',
        background: '#F9CC04 !important',
        textTransform: 'none',

        '&:hover': {
            '&.MuiButton-root': {
                background: '#F9CC04',
            },
            // '& span.MuiButton-label': {
            //     color: '#F9CC04',
            // },
        },
        '& span.MuiButton-label': {
            color: '#383838',
        },
    },

    popupButtonSecondary: {
        border: '1px solid #F9CC04 !important',
        padding: '0px 20px',
        borderRadius: '16px',
        color: '#F9CC04 !important',
        textTransform: 'none',
    },

    buttonNoLoadFlash: {
        transition: 'none !important',
        '& .MuiSvgIcon-root': {
            transition: 'none !important',
        },
    },

    buttonSvgIconSmall: {
        minWidth: 'unset',
        '& .MuiSvgIcon-root': {
            width: 18,
            height: 18,
        },
    },

    buttonNoHover: {
        '&:hover': {
            background: 'none',
        },
    },

    roundedMuseButton: {
        borderRadius: 20,
        border: '1px solid #F9CC04',
        padding: 0,
        background: '#202122',

        '&:hover': {
            // border: 0,
            background: '#F9CC04',
            border: '1px solid #F9CC04',
        },
    },

    roundedMuseButtonGroup: {
        borderRadius: 20,
        border: '1px solid #F9CC04',
        padding: 0,
        background: '#202122',
    },

    roundedMuseButtonLabel: {
        color: '#F9CC04',
        padding: '5px 15px',
        fontSize: '14px',

        '&:hover': {
            color: '#202122',
        },

        '&::placeholder': {
            color: 'transparent',
        },
    },

    roundedFilledMuseButton: {
        borderRadius: 20,
        border: '1px solid #F9CC04',
        padding: 0,
        background: '#f9cc04 !important',
        transition: 'filter 0.333s 0s',

        '&:hover': {
            background: '#F9CC04',
            filter: 'brightness(0.8)',
            border: '1px solid #F9CC04',
        },
    },

    roundedFilledMuseButtonLabel: {
        color: '#202122',
        padding: '5px 15px',
        fontSize: '14px',

        '&:hover': {
            color: '#202122',
        },

        '&::placeholder': {
            color: 'transparent',
        },
    },

    roundedOutlineMuseButton: {
        borderRadius: 20,
        border: '1px solid #f9cc04',
        padding: 0,
        background: 'transparent',
        transition: 'border 0.5s 0s',

        '&:hover': {
            border: '1px solid #F9CC04',
        },
    },

    roundedOutlineMuseButtonLabel: {
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#f9cc04',
        padding: 0,
        fontSize: '14px',
        textTransform: 'none',
        textAlign: 'center',

        '&:hover': {
            color: '#f9cc04',
        },

        '&::placeholder': {
            color: 'transparent',
        },
    },

    roundedOutlineSecondaryMuseButton: {
        borderRadius: 20,
        border: '1px solid #3F3F3F',
        padding: 0,
        background: 'transparent',
        transition: 'border 0.5s 0s',

        '&:hover': {
            border: '1px solid #F9CC04',
        },
    },

    roundedOutlineSecondaryMuseButtonLabel: {
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#f9cc04',
        padding: '5px 25px',
        fontSize: '14px',
        textTransform: 'none',
        textAlign: 'initial',

        '&:hover': {
            color: '#f9cc04',
        },

        '&::placeholder': {
            color: 'transparent',
        },
    },

    buttonLabelSmall: {
        fontSize: '85%',
    },

    circleButton: {
        height: '50px',
        width: '50px',
        minWidth: 'unset',
        borderRadius: '25px',
    },

    circleButtonDisabled: {
        border: '1px solid #5d5d5d !important',
        '& .MuiButton-label': {
            color: '#5d5d5d',
        },
    },

    disabled: {
        opacity: 0.7,
    },

    inviteButton: {
        border: '1px solid #f9cc04 !important',
        background: 'transparent',
        textTransform: 'none',
    },

    inviteButtonDisabled: {
        '& .MuiButton-label': {
            color: '#f9cc04',
        },
        opacity: 0.75,
    },

    roundedOutlinedButton: {
        border: '1px solid rgba(249, 204, 4, 0.8)',
        borderRadius: '16px',
        '& .MuiButton-label': {
            fontSize: '12px',
            color: '#f9cc04',
            textTransform: 'none',
        },
    },

    roundedOutlinedButtonFilled: {
        '& .MuiButton-label': {
            color: '#202122',
        },
    },

    autoCompleteContainer: {
        '& .MuiFormHelperText-root': {
            textAlign: 'center',
            paddingLeft: '0px',
        },
    },

    autoCompleteInput: {
        background: 'rgba(217,217,217,0.1)',
        paddingLeft: '10px',
        height: '40px',
        borderRadius: '5px 5px 0px 0px',
        '& .MuiAutocomplete-input': {
            color: '#aaa',
            fontSize: '14px',
        },

        '&.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
            textAlign: 'left',
        },
    },

    museAutoComplete: {
        border: '1px solid #4c4c4c',
        background: '#2f2f2f',
        color: '#f1f1f1',
        fontSize: '14px',

        '&.MuiAutocomplete-listbox': {
            padding: 0,
        },

        '& .MuiAutocomplete-option': {
            minHeight: 'auto',
            borderBottom: '1px solid #4c4c4c',
            '&:hover': {
                backgroundColor: 'rgb(255 255 255 / 10%)',
            },
        },
    },

    museAutoCompleteAdornment: {
        color: '#F9CC04',
    },

    museAutoCompletePopper: {
        '& .MuiAutocomplete-paper': {
            margin: 0,
        },
    },

    museLink: {
        color: '#F9CC04',
        textDecoration: 'underline',
        cursor: 'pointer',
        display: 'flex',

        '& .MuiSvgIcon-root': {
            fontSize: '14px',
            marginLeft: '2px',
            marginTop: '2px',
        },
    },

    museLinkAlert: {
        color: '#202122',
        textDecoration: 'underline',
        cursor: 'pointer',
        display: 'inline',
    },

    museLinkNoUnderline: {
        textDecoration: 'none',
    },

    museSwitchRoot: {
        width: '53px',
        height: '28px',
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#fafafa',
        },
    },

    museSwitchRootDisabled: {
        opacity: 0.5,
    },

    museSwitchRootRight: {
        marginLeft: '10px',
    },

    museSwitchBase: {
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#F9CC04',
            opacity: 1,
        },
    },

    museSwitchThumb: {
        width: '12px',
        height: '12px',
    },

    museSwitchTrack: {
        height: '6px',
    },

    customTooltipContainer: {
        margin: '0.5rem',
    },

    customTooltipTextLast: {
        fontSize: '0.75rem',
        lineHeight: 1.3,
    },

    customTooltipText: {
        fontSize: '0.75rem',
        lineHeight: 1.3,
        marginBottom: '0.3rem',
    },

    customTooltipLink: {
        fontSize: '0.66rem',
    },

    alertSmall: {
        '&.MuiAlert-standardInfo': {
            color: '#202122',
            backgroundColor: '#F9CC04',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,

            '& .MuiAlert-icon': {
                fontSize: '1rem',
                marginRight: '0.4rem',
                color: '#202122',
            },
        },

        '& .MuiAlert-message': {
            fontSize: '0.75rem',
        },
    },

    alertLessPadding: {
        '&.MuiAlert-standardInfo': {
            padding: '6px',
        },
        '& .MuiAlert-message': {
            padding: 0,
        },
    },

    alertOutline: {
        '&.MuiAlert-standardInfo': {
            color: '#F9CC04',
            backgroundColor: 'transparent',
            border: '1px solid',

            '& .MuiAlert-icon': {
                fontSize: '1rem',
                marginRight: '0.4rem',
                color: '#F9CC04',
            },
        },

        '& .MuiAlert-message': {
            fontSize: '0.75rem',
        },
    },

    alertColorWhite: {
        '&.MuiAlert-standardInfo': {
            color: '#dddddd',

            '& .MuiAlert-icon': {
                color: '#dddddd',
            },
        },
    },

    alertOutlineNoBorder: {
        '&.MuiAlert-standardInfo': {
            color: '#F9CC04',
            backgroundColor: 'transparent',

            '& .MuiAlert-icon': {
                fontSize: '1rem',
                marginRight: '0.4rem',
                color: '#F9CC04',
            },
        },

        '& .MuiAlert-message': {
            fontSize: '0.75rem',
        },
    },

    verificationAlert: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        justifyContent: 'center',
    },

    topCenterContainer: {
        padding: '0.7rem 1rem 0 0.7rem',
        display: 'flex',
        zIndex: 100,
    },

    topLeftCornerContainer: {
        padding: '0.7rem 0 0 1rem',
        display: 'flex',
        justifyContent: 'flex-start',
        height: 0,
        zIndex: 100,
    },

    topRightCornerContainer: {
        padding: '0.7rem 1rem 0 0',
        display: 'flex',
        justifyContent: 'flex-end',
        height: 0,
        zIndex: 100,
    },

    titlebarButton: {
        padding: '0 10px',
        minWidth: 0,
        width: '46px',
        borderRadius: 0,
        height: '100%',
        '&:hover': {
            backgroundColor: '#505050',
        },
        '& .MuiButton-label': {
            color: '#cccccc',
        },
    },

    titlebarMinimizeButtonScaling: {
        '& .MuiButton-label': {
            transform: 'scaleY(0.333)',
        },
    },

    titlebarMaximizeButtonScaling: {
        '& .MuiButton-label': {
            transform: 'scale(0.6)',
        },
    },

    titlebarCloseButton: {
        '& .MuiButton-label': {
            transform: 'scale(0.8)',
        },
        '&:hover': {
            backgroundColor: '#D71526',
        },
    },

    sidebarTooltipMarginAdjustment: {
        margin: '0px 0',
        '&.MuiTooltip-tooltipPlacementBottom': {
            margin: '14px 0',
        },
        // display: 'none'
    },

    museTextFieldLight: {
        width: '100%',

        '& .MuiOutlinedInput-multiline': {
            color: '#f1f1f1',
            fontSize: '14px',
            padding: 14,
        },

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f1f1f1',
        },

        '& .MuiOutlinedInput-root.Mui-focused': {
            borderColor: '#f1f1f1',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#f1f1f1',
            },
        },

        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f1f1f1',
        },
    },

    museTextFieldLightHelpText: {
        color: '#C33E36',
    },

    museBugReportTextField: {
        width: '100%',
        maxWidth: '450px',

        '& .MuiOutlinedInput-multiline': {
            color: '#F9CC04',
            fontSize: '14px',
        },

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(63, 63, 63)',
        },

        '& .MuiOutlinedInput-root.Mui-focused': {
            borderColor: 'rgb(63, 63, 63)',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgb(63, 63, 63)',
            },
        },

        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(63, 63, 63)',
        },
    },

    museBugReportTextFieldHelpText: {
        color: '#C33E36',
    },

    navMenu1: {
        width: '110px',
        padding: 0,
        zIndex: 2,
        backgroundColor: '#202122',

        '& .MuiListItem-button:hover': {
            backgroundColor: 'rgba(75, 75, 75, 1)',
        },

        '& .MuiTypography-root': {
            overflowWrap: 'break-word',
        },
    },

    navMenu1Selected: {
        backgroundColor: 'rgba(75, 75, 75, 1)',
    },

    navMenu2: {
        padding: 0,
        backgroundColor: '#202122',

        '& .MuiListItem-button:hover': {
            backgroundColor: 'rgba(75, 75, 75, 1)',
        },
    },

    navMenu2Selected: {
        backgroundColor: 'rgba(75, 75, 75, 1)',
    },

    navMenuTextEllipsis: {
        '& .MuiTypography-root': {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
    },

    badgeSmall: {
        // NOTE: corresponds to overlap='rectangle'; is deprecated.
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            transform: 'scale(0.8) translate(16%, -16%)',
        },
        '& .MuiBadge-anchorOriginTopRightRectangular': {
            transform: 'scale(0.8) translate(16%, -16%)',
        },
        '& .MuiBadge-invisible': {
            transform: 'scale(0) translate(50%, -50%) !important',
        },
    },

    badgeCommunityMessagesNav: {
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            transform: 'scale(0.8) translate(-10%, 16%)',
        },
        '& .MuiBadge-invisible': {
            transform: 'scale(0) translate(50%, -50%) !important',
        },
    },

    checkboxCheck: {
        padding: 0,
        color: '#f1f1f1 !important',
        '& .MuiSvgIcon-root': {
            fontSize: '1.15rem',
        },
    },

    formControlHidden: {
        position: 'absolute',
        visibility: 'hidden',
        right: '0',
    },

    communityCollaboratorTable: {
        margin: '0 5px',
        borderCollapse: 'collapse',

        '& thead > tr': {
            borderBottom: 'solid 1px #696969',
        },

        '& tbody > tr': {
            borderBottom: 'solid 1px #696969',
        },

        '& th': {
            color: '#f1f1f1',
            fontWeight: 'normal',
            fontSize: '0.775rem',
            textAlign: 'start',
            padding: '6px 10px',
        },

        '& td': {
            fontWeight: 'normal',
            fontSize: '0.75rem',
            padding: '6px 10px',
        },

        '& .cell-username': {
            width: '20%',
            wordBreak: 'break-all',
        },

        '& .cell-status': {
            width: '10%',
        },

        '& .cell-basic': {
            color: '#f1f1f1',
            minWidth: '25%',
        },

        '& .cell-clickable': {
            cursor: 'pointer',
        },

        '& .cell-leftmost': {
            paddingLeft: '12px',
        },

        '& .cell-rightmost': {
            paddingRight: '22px',
        },
    },

    communityCollaboratorPaginationController: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .page-status': {
            color: '#f1f1f1',
            width: 50,
            textAlign: 'center',
        },

        '& .MuiSvgIcon-root': {
            color: '#f9cc04',
            fontSize: '1.4rem',
        },

        '& .disabled': {
            opacity: 0.5,
        },
    },

    copyStylesPreloadHiddenDiv: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        visibility: 'hidden',
        pointerEvents: 'none',
        overflow: 'hidden',
    },

    alignRight: {
        marginLeft: 'auto',
        display: 'block',
    },

    basicDialogContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 30px',
        backgroundColor: '#323334',
        width: '420px',
        height: '100%',
        justifyContent: 'center',
    },

    newInputHeaderSpacing: {
        color: '#f1f1f1',
        fontSize: '14px',
        minHeight: 0,
        fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
        lineHeight: '18px',
        letterSpacing: 0,
        '&.MuiListItem-root.Mui-disabled': {
            padding: '16px 27px 8px 20px',
        },
    },

    newInputListIcon: {
        color: '#f1f1f1',
        fontSize: '14px',
        minHeight: 0,
        fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
        lineHeight: '18px',
        letterSpacing: 0,
        '&.MuiListItem-root': {
            padding: '8px 27px 8px 16px',
        },

        '& .MuiCheckbox-root.MuiButtonBase-root': {
            padding: '3px 9px',
        },

        '& .MuiCheckbox-colorSecondary.Mui-checked': {},
    },

    audioInputIcon: {
        // '& .MuiListItemIcon-root': {
        minWidth: '20px',
        // },
    },

    secondaryPopupButton: {
        background: '#4F4F4F !important',
        border: 'none',
        width: '80px',
        height: '40px',
        borderRadius: '40px',

        '& .MuiButton-label': {
            color: '#F1F1F1',
            textTransform: 'none',
            fontSize: '14px',
        },

        '&:hover': {
            background: 'rgb(79, 79, 79)',
        },
    },

    primaryPopupButton: {
        background: '#F9CC04 !important',
        border: 'none',
        width: '85px',
        height: '40px',
        borderRadius: '40px',

        '& .MuiButton-label': {
            color: '#202122',
            textTransform: 'none',
            fontSize: '14px',
        },

        '&:hover': {
            background: '#F9CC04',
        },
    },

    divider: {
        background: 'transparent',
        height: '1px',
        width: ' 100%',
        display: 'flex',
        margin: '8px 0px',
    },

    customTimeSelect: {
        margin: '0px 10px',
    },

    icon: {
        color: '#5D5D5D',

        '&.MuiSelect-iconOpen': {
            zIndex: 10000,
            color: '#F9CC04',
        },
    },

    squareCheckbox: {
        padding: 0,
        color: '#595959',
        background: '#303030',
        width: '18px',
        height: '18px',
        borderRadius: 0,

        '&:hover': {
            background: '#303030',
        },

        '&.MuiCheckbox-colorSecondary.Mui-checked': {
            color: '#F9CC04',
        },
    },

    checkboxIcon: {
        height: 10,
        width: 10,
        borderRadius: 5,
        border: '1px solid #F1F1F1',
        backgroundColor: '#transparent',

        '$root.Mui-focusVisible &': {},
        'input:hover ~ &': {},
        'input:disabled ~ &': {},
    },
    checkedIcon: {
        backgroundColor: '#F9CC04',
        borderRadius: 5,
        '&:before': {
            display: 'block',
            width: 10,
            height: 10,
            content: '""',
        },
        'input:hover ~ &': {},
    },

    museCheckbox: {
        padding: '0px',
        margin: '9px 9px 9px 0px',

        '& .MuiSvgIcon-root': {
            color: '#999',
        },

        '&.Mui-checked svg': {
            fill: '#F9CC04',
        },
    },

    museChcekboxChecked: {
        background: '#F9CC04',
    },

    disabledSelection: {
        margin: '8px 0px',
        padding: '8px 24px',
        width: '310px',
        color: '#f9cc04',
        border: '1px solid #f9cc04',
        fontSize: '14px',
        lineHeight: '18px',
        borderRadius: '20px',
    },

    midiInputContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },

    floatingMidiMeter: {
        position: 'absolute',
        right: '-65px',
    },

    screenShareToolbar: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        opacity: 0.5,
        backgroundColor: 'black',
        color: 'white',
        padding: 3,
        zIndex: 10000,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

        '&:hover': {
            opacity: 1,
        },
    },

    roundedButton: {
        fontSize: '12px',
        color: '#5d5d5d',
        cursor: 'pointer',
        border: 'solid rgb(93,93,93) 1px',
        borderRadius: 16,
        padding: '2px 8px',
        boxShadow: 'none',
        backgroundColor: 'transparent',

        '& .MuiButton-label': {
            fontSize: '12px',
            textTransform: 'none',
        },

        '&:hover': {
            backgroundColor: 'transparent',
            filter: 'brightness(90%)',
            boxShadow: '0px 1px 5px 0px #ccc',
        },
    },

    settingsPageSelectScreenButton: {
        borderRadius: '16px',
        border: 'solid rgb(93,93,93) 1px',
        transition: 'border 75ms',

        '& .MuiButton-label': {
            fontSize: '14px',
            textTransform: 'none',
            display: 'block',
            textAlign: 'left',
            paddingLeft: 10,
            transition: 'color 75ms',
        },

        '&:hover': {
            color: '#F9CC04',
            borderColor: '#F9CC04',

            '& .MuiButton-label': {
                color: '#F9CC04',
            },
        },
    },

    settingsPageSelectScreenButtonSelected: {
        color: '#F9CC04',
        borderColor: '#F9CC04',

        '& .MuiButton-label': {
            color: '#F9CC04',
        },
    },

    stopSharingButton: {
        '& .MuiButton-label': {
            marginBottom: -2,
            marginTop: -2,
        },
    },

    buttonOutlineWhite: {
        borderColor: '#f1f1f1',
        '& .MuiButton-label': {
            color: '#f1f1f1',
        },
    },

    channelSelect: {
        '&:hover .MuiSelect-icon': {
            // color: '#F9CC04',
        },

        '& .MuiSelect-select.MuiSelect-select': {
            border: '1px solid #5D5D5D',
            borderRadius: '6px',
            padding: '6px 20px 6px 10px',
            lineHeight: '14px',
            color: '#ccc',
            fontSize: '14px',
            background: '#313131',

            '&:hover': {
                // borderColor: '#F9CC04',
                // color: '#F9CC04',
            },

            '&:focus': {
                // borderRadius: '25.5px',
            },
        },

        '& .MuiSelect-icon': {
            width: '0.9em',
            height: '0.9em',
            color: '#ccc',
        },

        '&.Mui-disabled .MuiSelect-root': {
            color: '#7e7e7e',
            cursor: 'not-allowed',
        },

        '&.Mui-disabled .MuiSelect-icon': {
            color: '#7e7e7e',
            cursor: 'not-allowed',
        },
    },

    selectMenuRoot: {
        boxSizing: 'border-box',
        width: '220px',
        border: '1px solid rgb(63, 63, 63)',
        borderRadius: '20px',
        backgroundColor: '#202122',

        '& ul': {
            padding: '0px',
        },

        '& li': {
            color: '#F1F1F1',
            fontFamily: 'Inv Maison Neue,-apple-system,BlinkMacSystemFont,Open Sans,sans-serif',
            fontSize: '14px',
            letterSpacing: 0,
            lineHeight: '18px',
            padding: '8px 27px 8px 24px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            minHeight: 0,

            '& .MuiTypography-root': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },

            // This prevents the ugly default checkbox from appearing on electron modals.
            '& input': {
                display: 'none',
            },
            '& .MuiListItemText-root': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',

                flex: '1 1 auto',
                minWidth: 0,
                marginTop: '4px',
                marginBottom: '4px',
            },
            '& .MuiButtonBase-root': {
                padding: '9px',
            },
        },

        '& li.Mui-selected': {
            color: '#F9CC04',
        },

        '& li.Mui-selected .MuiListItemText-primary': {
            color: '#F9CC04',
        },

        '&:hover .MuiListItem-button:hover': {
            backgroundColor: 'rgb(255,255,255,.1)',
        },

        '& .MuiListSubheader-root': {
            borderTop: '1px solid #3F3F3F',
            padding: '0',
        },
    },
}))

export default useMuseStyles
